import React from 'react';
import { Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  return (
    <Select
      value={i18n.language}
      onChange={(language) => i18n.changeLanguage(language)}
      style={{ width: 100 }}
      suffixIcon={<GlobalOutlined />}
      options={[
        { value: 'pt', label: 'PT' },
        { value: 'en', label: 'EN' }
      ]}
    />
  );
};

export default LanguageSwitcher;
